import type { ReactNode } from 'react';

import { useLanguage } from '../lib/i18n/LanguageContext';
import { Modal } from './Modal';

/**
 * A styled stand-in for `window.alert`. Wrap the call site in
 * `<AnimatePresence>` (see Modal.tsx) for the open/close transition.
 */
export function AlertDialog({
  title,
  body,
  okLabel,
  onClose,
}: {
  title: string;
  body?: ReactNode;
  okLabel?: string;
  onClose: () => void;
}) {
  const { dict } = useLanguage();
  return (
    <Modal title={title} onClose={onClose}>
      {body != null && <div className="modal-body alert-dialog-body">{body}</div>}
      <div className="modal-actions">
        <button type="button" onClick={onClose} autoFocus>
          {okLabel ?? dict.common.close}
        </button>
      </div>
    </Modal>
  );
}
